import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68c8bdc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "refContainer",
  class: "h200px pr"
}
const _hoisted_2 = { ref: "refRoughView" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", _hoisted_2, null, 512),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentBox, ({ layout, children }, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "pa df aic tal plr-4px lh-16px border-box",
        key: idx,
        style: _normalizeStyle({
        top: layout.top + 'px',
        left: layout.left + 'px',
        width: layout.width + 'px',
        height: layout.height + 'px',
      })
      }, _toDisplayString(children), 5))
    }), 128))
  ], 512))
}